// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminAppointmentMethod } from './admin-appointment-method';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AppointmentMethod extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  appointmentMethodId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  locationId!: number;
  longDescription!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminAppointmentMethods!: AdminAppointmentMethod[];
}

